__turbopack_context__.v({
  "circleAnimation": "TempratureCard-module__4qV2aa__circleAnimation",
  "root": "TempratureCard-module__4qV2aa__root" + " " + __turbopack_context__.i(975967)["BentoCardSizeCss"],
});
